import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListHeader";
import { tableStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

tableStyles.container = {
    css: css`
        overflow: auto;
        > table[class^="DataTableStyle"] {
            >thead{
                > tr[class^="DataTableHeadStyle"] {
                    >${DataTableCellBase}{
                        >${StyledButton}{
                            ${TypographyStyle}{
                                font-size: 16px;
                            }
                            ${IconWrapper}{
                                color: ${getColor("primary")};
                            }
                        }
                    }
                }
            }
            >tbody{
                > tr[class^="DataTableRowStyle"] {
                    >${DataTableCellBase}{
                        >${TypographyStyle}{
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    `,
}

headerStyles.orderApprovalCountGridItem = {
    width: 11,
    css: css`
        font-weight: 600;
        margin-top: 8px;
    `,
}

headerStyles.toggleFilterIcon = {
    size: 24,
    css: css`
    color: ${getColor("primary")};
    `
}